import { render, staticRenderFns } from "./TabsContainer.vue?vue&type=template&id=7cede332&scoped=true&"
import script from "./TabsContainer.vue?vue&type=script&lang=js&"
export * from "./TabsContainer.vue?vue&type=script&lang=js&"
import style0 from "./TabsContainer.vue?vue&type=style&index=0&id=7cede332&scoped=true&lang=css&"
import style1 from "./TabsContainer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cede332",
  null
  
)

export default component.exports